/**
 * App-side delegate (OpenSpec `monorepo-session-data-core` D2). The transcript
 * hook and its commands moved to `@heidi/session/data`; this path keeps every
 * importer compiling — and keeps the old call signature — by reading the two
 * app-owned inputs the package may not touch (the Rematch `timerModel` and the
 * build profile) and passing them in as parameters (the W3c delegate pattern).
 * Deleted at Z2 once task Z1's codemod re-points the importers.
 */
import { type RootState } from '@/store';
import { isOnPrem } from '@/utils/buildProfile';
import {
  getTranscriptRefetchInterval as getTranscriptRefetchIntervalCore,
  useQueryTranscriptBySessionId as useQueryTranscriptBySessionIdCore,
} from '@heidi/session/data';
import { useSelector } from 'react-redux';

export { GET_TRANSCRIPT_BY_SESSION_ID } from '@heidi/session/contracts';
export {
  invalidateTranscriptBySessionId,
  preFetchTranscripts,
} from '@heidi/session/data';

/**
 * Old-path signature preserved: the package fn takes `isOnPrem` explicitly;
 * this wrapper binds the app's build profile.
 */
export const getTranscriptRefetchInterval = (
  data: Parameters<typeof getTranscriptRefetchIntervalCore>[0],
  isRecording = false
): number | false => getTranscriptRefetchIntervalCore(data, isRecording, isOnPrem);

export function useQueryTranscriptBySessionId(sessionId: string) {
  const isRecording = useSelector((state: RootState) => state.timerModel.isRunning);
  return useQueryTranscriptBySessionIdCore(sessionId, { isRecording, isOnPrem });
}
